<template>
    <tbody>
        <template v-if="sportsOrSpecials(data.ticket.type)">
            <tr
                v-for="(event, index) in data.ticket.events"
                :key="index + event.eventId"
                :class="eventStatusClass(event.status)"
            >
                <td colspan="1" class="p-l-1 p-y-1">{{ sportEventProgress(event) }}</td>
                <td colspan="2" class="p-y-1">{{ event.inputCode.event }}</td>
                <td colspan="1" class="p-y-1">{{ displayFix(event) }}</td>
                <td colspan="1" class="p-y-1">
                    {{ cleanUndefined(displayName(event)) }}
                </td>
                <td colspan="1" class="p-y-1">{{ displayDate(event) }}</td>
                <td colspan="1" class="p-y-1">
                    {{ interpolatePart(event.odd.name, event.odd.specifiers, event.eventId) }}
                </td>
                <td colspan="1" class="p-y-1">
                    {{ numberFormat(event.odd.coefficient) }}
                </td>
            </tr>
        </template>
        <tr v-else-if="lotto(data.ticket.type)">
            <td colspan="1" class="p-l-1 p-y-1">
                <span>{{ $t(data.ticket.status) | upperCase }} </span>
            </td>
            <td colspan="1" class="p-y-1">
                <span>
                    {{ lottoTicket.inputCode.event }}
                </span>
            </td>
            <td colspan="1" class="p-y-1">
                <span>
                    {{ displayFix(lottoTicket) }}
                </span>
            </td>
            <td colspan="2" class="p-y-1">
                <span>
                    {{ cleanUndefined(lottoTicket.name.toString()) }}
                </span>
            </td>
            <td colspan="1" class="p-y-1">
                <span>
                    {{ displayDate(lottoTicket) }}
                </span>
            </td>
            <td colspan="4" class="p-y-1">
                <div class="lotto-ball__container">
                    <div
                        v-for="(lottoEvent, index) in data.ticket.events"
                        :key="index + lottoEvent.eventId"
                    >
                        <div
                            class="lotto-ball"
                            :class="eventStatusClass(lottoEvent.status)"
                        >
                            {{ lottoEvent.odd.name }}
                        </div>
                    </div>
                </div>
            </td>
            <td colspan="1" class="p-y-1">
                <span>
                    {{ lottoTicket.odd.coefficient }}
                </span>
            </td>
        </tr>
    </tbody>
</template>

<script>
    import { localeNumberFormat } from '@src/terminal/core/services/gravity/helpers/math';
    import {
        isSportsOrSpecials,
        isLotto,
    } from '@src/terminal/app/modules/checkTicket/util';
    import liveBettingSpecifiersFormatter from '@core/services/offer/_private/LiveBettingSpecifiersFormatter';
    import OfferService from '@core/services/offer/OfferService';
    import { partition as _partition } from '@lodash';
    import SpecialsService from '@core/services/specials/SpecialsService';

    export default {
        name: 'TicketBody',
        props: {
            data: Object,
        },
        data() {
            return {
                reqEvents: [],
            };
        },
        async mounted() {
            this.reqEvents = await this.getReqEvents();
        },
        computed: {
            lottoTicket() {
                return this.data.ticket.events[0] || null;
            },
        },
        methods: {
            numberFormat: localeNumberFormat,
            sportsOrSpecials: isSportsOrSpecials,
            lotto: isLotto,
            findMatchById(matches, id) {
                return matches.find((match) => match.id === parseInt(id, 10));
            },
            sportEventProgress(event) {
                const now = new Date();
                const eventStartDate = new Date(event.date);
                const isDefaultStatus = ['lost', 'win', 'refund'].includes(event.status);
                if (now.getTime() > eventStartDate.getTime() && !isDefaultStatus) {
                    return this.$t('inProgress').toUpperCase();
                }
                return this.$t(event.status).toUpperCase();
            },
            eventStatusClass(eventStatus) {
                switch (eventStatus) {
                    case 'win':
                        return 'win';
                    case 'lost':
                        return 'lost';
                    default:
                        return 'active';
                }
            },
            displayFix(event) {
                return event.odd.isFix ? this.$t('fix') : '';
            },
            cleanUndefined(string) {
                return string.replace('undefined', '');
            },
            displayName(event) {
                return `${event.name[0]}, ${event.name[1]}`;
            },
            displayDate(event) {
                const date = new Date(event.date);
                return `${date.getDate()}. ${date.getMonth() + 1}. ${date.getFullYear()}`;
            },
            interpolatePart(oddName, specifiers, id) {
                const realEvent = this.findMatchById(this.reqEvents, id);
                return liveBettingSpecifiersFormatter.format(
                    oddName,
                    specifiers,
                    realEvent
                );
            },
            async getReqEvents() {
                const eventIds = this.data.ticket.events.map((event) => event.eventId);
                const [specials, regulars] = _partition(eventIds, (eventId) => eventId.startsWith('S'));
                const refinedSpecialIds = specials.map((specialId) => specialId.slice(1));
                const specialEvents = await SpecialsService.getInstance().getEventsById(refinedSpecialIds);
                const regularEvents = await OfferService.getInstance().getEventsById(regulars);
                return [...specialEvents, ...regularEvents];
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/terminal/app/modules/checkTicket/TicketBody.vue